import { render } from "./DeployVM.vue?vue&type=template&id=b2ff2e34&scoped=true"
import script from "./DeployVM.vue?vue&type=script&lang=js"
export * from "./DeployVM.vue?vue&type=script&lang=js"

import "./DeployVM.vue?vue&type=style&index=0&id=b2ff2e34&lang=less&scoped=true"
import "./DeployVM.vue?vue&type=style&index=1&id=b2ff2e34&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2ff2e34"]])

export default __exports__